// owner/shell/useOwnerSignOut.js — the owner experience's sign-out.
// One call for every sign-out button. Before logging out, this device's alerts are removed while the pass is still
// valid (§10 step 7 audit note 10; 8d): the store app removes its phone (owner/app/alerts/appAlerts.js) and the web
// removes its browser (owner/web/browserAlerts.js), each registering its step here.

import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';

let beforeSignOut = null;

/** The app registers its pre-sign-out step (8d). Never awaited forever: sign-out must always complete. */
export const setBeforeSignOut = (step) => { beforeSignOut = step; };

/**
 * `sessionEnded`: the server has already ended this sign-in (a password change ends every session and removes the
 * owner's phones), so the before-step is skipped — a request on the dead pass would be refused, fail its renewal and
 * flag the sign-in screen with «انتهت الجلسة» (8d audit).
 */
const useOwnerSignOut = () => {
  const { logout } = useContext(AuthContext);
  return async ({ sessionEnded = false } = {}) => {
    if (beforeSignOut && !sessionEnded) {
      try { await beforeSignOut(); } catch (error) { /* sign-out never depends on the network */ }
    }
    logout();
  };
};

export default useOwnerSignOut;
